import React, { Component } from 'react';
import DescriptiveText from './components/descriptiveText.js';
import CustomerHero from './components/customerHero';
import WebscreenSingle from './components/webscreenSingle';
import WebscreenDouble from './components/webscreenDouble';
import WebscreenMobile from './components/webscreenMobile';
import MaxWidthVideo from './components/maxWidthVideo';
import CustomerQuote from './components/customerQuote';
import Footer from "./components/footer";

export default class Soeventful extends Component {
  constructor(props) {
      super(props);
      this.state = {
  			animations: []
  		};
  }
  componentDidMount() {
  }
  render() {
    return (
      <div>
        <CustomerHero company="So Eventful"
          title="A wedding and event planning company that leads their industry by example of excellence"
          video="video/soeventful-video.mp4"
          backgroundImage="images/soeventful-hero.jpg"
          overlayColor="#f9b19b"
        />
        <div className="white-background large-margin-top">
          <DescriptiveText
            title="Company Overview"
            text="So Eventful is an award-winning wedding and event planning company specializing in creating memorable experiences that last a lifetime. Located in the California Wine Country, they are an incredibly skilled team of planners that pride themselves on their attention to detail and high caliber wedding and event production."
          />
          <WebscreenSingle
            image="images/soeventful-long.jpg"
          />
          <DescriptiveText
            title="A Personalized Design Experience"
            text="So Eventful was looking to make the switch from a templated website to a solution that was as unique and customized as the services they offered as a company. Alpine Design developed a website that acted as a visually-rich and informative portfolio piece to accurately represent the types of events they create."
          />
          <WebscreenDouble
            image1="images/soeventful-side-by-side-1.jpg"
            image2="images/soeventful-side-by-side-2.jpg"
          />
          <DescriptiveText
            title="Mobile-first Development"
            text="75% of So Eventful's users came from mobile devices so it was crucial for the website to work well and look great on any device. By prioritizing the design on its effectiveness in a mobile environment we were able to produce a website that communicated the brand's messaging beautifully regardless of the screen size."
          />
          <WebscreenMobile
            image1="images/soeventful-mobile-1.jpg"
            image2="images/soeventful-mobile-2.jpg"
            image3="images/soeventful-mobile-3.jpg"
          />
          <DescriptiveText
            title="A Video Worth 1000 Words"
            text="With hours of video footage from previously executed events, we felt we came across a goldmine. Rather than the typical 'hero image,' we put together a highlight reel that acted as an interactive representation of their most stunning work."
          />
          <MaxWidthVideo
            video="video/soeventful-video.mp4"
          />
          <DescriptiveText
            title="Captivating Content"
            text="The central goal for So Eventful was to create a website that immediately captured the attention of potential clients. In such a competitive industry, it was important for So Eventful to have a website that provided users with a unique experience that set them apart, and resonated well with clientele in showing them what their dream day could look like."
          />
          <CustomerQuote
            thumb="images/soeventful-quote-thumb.jpg"
            name="Marisa Manna Ferrell, Owner, So Eventful"
            quote="Hiring a wedding planner takes a connection as well as a vision.  With what Alpine Design was able to create, we can now connect with a potential client in a way we never thought possible.  The passion our team has for creating such memorable events jumps off each and every web page.  After the launch of our new website we have seen an increase in traffic, duration of viewing, clients inquiring further about our services, as well as our closing rate of sales.  We can't thank the team at Alpine Design enough for making the process flow seamlessly as well as their out of the box thinking and their ability to create a work of art that is our website."
            overlayColor="#f9b19b"
            backgroundImage="images/soeventful-quote-background.jpg"
          />
        </div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/soeventful.js